import { IService } from './IService';
import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { ToastService } from './toast-service';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class ListViewDragAndDropService implements IService {

    constructor(public af: AngularFireDatabase, private loadingService: LoadingService, private toastCtrl: ToastService) { }

    getId = (): string => 'dragAndDrop';

    getTitle = (): string => 'Drag and Drop';

    getAllThemes = (): Array<any> => {
        return [
            { 'url': 'drag-and-drop/0', 'title': 'Medium item with avatar 2', 'theme': 'layout1' },
            { 'url': 'drag-and-drop/1', 'title': 'Products + header image', 'theme': 'layout2' },
            { 'url': 'drag-and-drop/2', 'title': 'Medium item with avatar 2', 'theme': 'layout3' }
        ];
    }

    getDataForTheme = (menuItem: any): Array<any> => {
        return this[
            'getDataFor' +
            menuItem.theme.charAt(0).toUpperCase() +
            menuItem.theme.slice(1)
        ]();
    }

    //* Data Set for page 1
    getDataForLayout1 = (): any => {
        return {
            'toolbarTitle': 'Medium item with avatar 2',
            'items': [
                {
                    'id': 1,
                    'title': 'Vanessa Ryan',
                    'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
                    'image': 'assets/imgs/avatar/18.jpg',
                    'icon':'reorder-three'
                },
                {
                    'id': 2,
                    'title': 'Meredith Hendricks',
                    'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
                    'image': 'assets/imgs/avatar/19.jpg',
                    'icon':'reorder-three'
                },
                {
                    'id': 3,
                    'title': 'Carol Kelly',
                    'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
                    'image': 'assets/imgs/avatar/20.jpg',
                    'icon':'reorder-three'
                },
                {
                    'id': 4,
                    'title': 'Barrera Ramsey',
                    'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
                    'image': 'assets/imgs/avatar/21.jpg',
                    'icon':'reorder-three'
                },
                {
                    'id': 5,
                    'title': 'Holman Valencia',
                    'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
                    'image': 'assets/imgs/avatar/22.jpg',
                    'icon':'reorder-three'
                },
                {
                    'id': 6,
                    'title': 'Marisa Cain',
                    'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
                    'image': 'assets/imgs/avatar/23.jpg',
                    'icon':'reorder-three'
                },
                {
                    'id': 7,
                    'title': 'Dejesus Norris',
                    'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
                    'image': 'assets/imgs/avatar/24.jpg',
                    'icon':'reorder-three'
                },
                {
                    'id': 8,
                    'title': 'Gayle Gaines',
                    'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
                    'image': 'assets/imgs/avatar/25.jpg',
                    'icon':'reorder-three'
                },
                {
                    'id': 9,
                    'title': 'Prince Phelps',
                    'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
                    'image': 'assets/imgs/avatar/19.jpg',
                    'icon':'reorder-three'
                },
                {
                    'id': 10,
                    'title': 'Keri Hudson',
                    'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
                    'image': 'assets/imgs/avatar/20.jpg',
                    'icon':'reorder-three'
                },
                {
                    'id': 11,
                    'title': 'Duran Clayton',
                    'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
                    'image': 'assets/imgs/avatar/21.jpg',
                    'icon':'reorder-three'
                }
            ]
        };
    }

    //* Data Set for page 2
    getDataForLayout2 = (): any => {
        return {
            'toolbarTitle': 'Products + header imager',
            'headerImage': 'assets/imgs/background/6.jpg',
            'title': 'CAR NEWS',
            'items': [
                {
                    'id': 1,
                    'title': 'Electric Ford',
                    'seller': 'LONDON, UNITED KINGDOM',
                    'image': 'assets/imgs/avatar/8.jpg',
                    'oldPrice': '$42.99',
                    'category': 'cars',
                    'newPrice': '$35.99',
                    'icon':'reorder-three'
                },
                {
                    'id': 2,
                    'title': 'Chevrolet Silverado',
                    'seller': 'GSTAAD, SWITZERLAND',
                    'image': 'assets/imgs/avatar/7.jpg',
                    'oldPrice': '$42.99',
                    'category': 'cars',
                    'newPrice': '$35.99',
                    'icon':'reorder-three'
                },
                {
                    'id': 3,
                    'title': 'Kia Sorento X-Lin',
                    'seller': 'SANTA BARBARA, CALIFORNIA',
                    'image': 'assets/imgs/avatar/6.jpg',
                    'oldPrice': '$42.99',
                    'category': 'cars',
                    'newPrice': '$35.99',
                    'icon':'reorder-three'
                },
                {
                    'id': 4,
                    'title': 'Mazda CX-30 Turbo',
                    'seller': 'PEBBLE BEACH, CALIFORNIA',
                    'image': 'assets/imgs/avatar/5.jpg',
                    'oldPrice': '$42.99',
                    'category': 'cars',
                    'newPrice': '$35.99',
                    'icon':'reorder-three',
                },
                {
                    'id': 5,
                    'title': 'Nissan 400Z',
                    'seller': 'MACAU, CHINA',
                    'image': 'assets/imgs/avatar/4.jpg',
                    'oldPrice': '$42.99',
                    'category': 'cars',
                    'newPrice': '$35.99',
                    'icon':'reorder-three'
                },
                {
                    'id': 6,
                    'title': 'Chevrolet Silverado',
                    'seller': 'MALIBU, CALIFORNIA',
                    'image': 'assets/imgs/avatar/3.jpg',
                    'oldPrice': '$42.99',
                    'category': 'cars',
                    'newPrice': '$35.99',
                    'icon':'reorder-three'
                },
                {
                    'id': 7,
                    'title': 'Nissan 400Z',
                    'seller': 'NEW YORK, NEW YORK',
                    'image': 'assets/imgs/avatar/2.jpg',
                    'oldPrice': '$42.99',
                    'category': 'cars',
                    'newPrice': '$35.99',
                    'icon':'reorder-three'
                }
            ]
        };
    }

    //* Data Set for page 3
    getDataForLayout3 = (): any => {
        return {
            'toolbarTitle': 'Medium Item With Avatar 2',
            'items': [
                {
                    'id': 1,
                    'title': 'Casa Palmero',
                    'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
                    'image': 'assets/imgs/avatar/24.jpg',
                    'button': 'Read more',
                    'iconButton': 'chevron-down',
                    'icon':'reorder-three'
                },
                {
                    'id': 2,
                    'title': 'Encore Macau',
                    'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
                    'image': 'assets/imgs/avatar/17.jpg',
                    'button': 'Read more',
                    'iconButton': 'chevron-down',
                    'icon':'reorder-three'
                },
                {
                    'id': 3,
                    'title': 'Nobu Ryokan Malibu',
                    'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
                    'image': 'assets/imgs/avatar/18.jpg',
                    'button': 'Read more',
                    'iconButton': 'chevron-down',
                    'icon':'reorder-three'
                },
                {
                    'id': 4,
                    'title': 'Palace Hotel Tokyo',
                    'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
                    'image': 'assets/imgs/avatar/19.jpg',
                    'button': 'Read more',
                    'iconButton': 'chevron-down',
                    'icon':'reorder-three'
                },
                {
                    'id': 5,
                    'title': 'Holman Valencia',
                    'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
                    'image': 'assets/imgs/avatar/20.jpg',
                    'button': 'Read more',
                    'iconButton': 'chevron-down',
                    'icon':'reorder-three'
                },
                {
                    'id': 6,
                    'title': 'Park Hyatt New York',
                    'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
                    'image': 'assets/imgs/avatar/21.jpg',
                    'button': 'Read more',
                    'iconButton': 'chevron-down',
                    'icon':'reorder-three'
                },
                {
                    'id': 7,
                    'title': 'Park Hyatt Vienna',
                    'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
                    'image': 'assets/imgs/avatar/22.jpg',
                    'button': 'Read more',
                    'iconButton': 'chevron-down',
                    'icon':'reorder-three'
                },
                {
                    'id': 8,
                    'title': 'The Peninsula Chicago',
                    'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
                    'image': 'assets/imgs/avatar/23.jpg',
                    'button': 'Read more',
                    'iconButton': 'chevron-down',
                    'icon':'reorder-three'
                }
            ]
        };
    }

    load(item: any): Observable<any> {
        const that = this;
        that.loadingService.show();
        if (AppSettings.IS_FIREBASE_ENABLED) {
            return new Observable(observer => {
                this.af
                    .object('listView/dragAndDrop/' + item.theme)
                    .valueChanges()
                    .subscribe(snapshot => {
                        that.loadingService.hide();
                        observer.next(snapshot);
                        observer.complete();
                    }, err => {
                        that.loadingService.hide();
                        observer.error([]);
                        observer.complete();
                    });
            });
        } else {
            return new Observable(observer => {
                that.loadingService.hide();
                observer.next(this.getDataForTheme(item));
                observer.complete();
            });
        }
    }
}
